import { render, staticRenderFns } from "./AccountEmailConfirmSend.vue?vue&type=template&id=4e98d760"
import script from "./AccountEmailConfirmSend?vue&type=script&lang=ts&external"
export * from "./AccountEmailConfirmSend?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports